import { getObjectType } from "@/utils/libraryObjectUtils";

import { File } from "../../components/graphql/schema.graphql";
import { BasicDataWorkspaceFragment } from "../../hooks/queries.graphql";
import {
  is3DMimetype,
  isAudioMimetype,
  isImageMimetype,
  isSVGMimeType,
  isVideoMimetype,
} from "../../utils/mimetype";
import { workspacePlanTierSorter } from "../../utils/tiers";
import { DriveFileItem, SimpleFile } from "./types";

export const imageExtensionsRegex = /\.(jpeg|jpg|png|gif|webp|svg|bmp)$/i;

export const canReforge = (
  file: Pick<File, "contentType" | "inferenceParameters">,
) => {
  return (
    file &&
    file.inferenceParameters &&
    (isImageMimetype(file.contentType) ||
      isVideoMimetype(file.contentType) ||
      is3DMimetype(file.contentType) ||
      isAudioMimetype(file.contentType))
  );
};

export const getWorkspaceForForge = ({
  fileWorkspace,
  userWorkspaces,
}: {
  fileWorkspace?: BasicDataWorkspaceFragment;
  userWorkspaces: BasicDataWorkspaceFragment[];
}) => {
  // Try the file's workspace if it has proper permissions
  if (fileWorkspace?.myPermissions?.includes("style:view")) {
    return fileWorkspace;
  }

  // Fall back to finding the first user workspace with proper permissions
  const userWorkspacesWithPermissions = userWorkspaces?.filter((w) =>
    w?.myPermissions?.includes("style:view"),
  );
  if (userWorkspacesWithPermissions?.length) {
    return userWorkspacesWithPermissions
      .slice() // creates a copy of the array
      .sort(workspacePlanTierSorter)[0];
  }
  return null;
};

export const isRasterImage = (item: DriveFileItem) => {
  if (item.__typename === "File") {
    return (
      getObjectType(item as SimpleFile) === "image" &&
      !isSVGMimeType(item.contentType)
    );
  }

  return false;
};

export const isMesh = (item: DriveFileItem) => {
  if (item.__typename === "File") {
    return getObjectType(item as SimpleFile) === "mesh";
  }

  return false;
};

export const isVideo = (item: DriveFileItem) => {
  if (item.__typename === "File") {
    return getObjectType(item as SimpleFile) === "video";
  }

  return false;
};
